module.exports = __webpack_public_path__ + "static/img/bodyImg.fb05aea4.png";